import React, {Component} from 'react';
import Highcharts from 'highcharts';
import Charts from '../Charts/Charts';
import './AllocationGraphs.css';

export class AllocationGraphs extends Component {

    setColors = (assets, colors) => {
        let length = colors.length;
        return assets.map((element, index) => {
            element.colorIndex = index % length;
            return element;
        });
    };

    sortAssets = (assets) => {
        // let leftSorted = this.getSortedBucket(assets, "Left");
        // let middleSorted = this.getSortedBucket(assets, "Middle");
        // let rightSorted = this.getSortedBucket(assets, "Right");
        // let result = leftSorted.concat(middleSorted).concat(rightSorted);
        // return result;
        return assets;
    };

    getSortedBucket = (assets, bucket) => {
        let sortedBucket = this.getBucket(assets, bucket);
        sortedBucket = sortedBucket.sort((ele1, ele2) => {
            return ele1.sortOrder - ele2.sortOrder;
        });
        return sortedBucket;
    };

    getBucket = (assets, bucket) => {
        return assets.filter((element) => {
            return element.superAssetClassAlignment === bucket;
        });
    };

    buildInnerCircle = (sortedAssets, colors) => {
        if (sortedAssets.length <= colors.length) {
            let innerSeries = sortedAssets.map((element, index) => {

                let color = colors[element.colorIndex];
                return this.createInnerCircleDataPoint(element, element.name, color);
            });

            if (innerSeries.length > 0) {
                innerSeries = innerSeries.filter((element) => {
                    return element.y > 0;
                });
                return innerSeries;
            } else {
                return "";
            }
        } else {
            return "";
        }
    };

    createInnerCircleDataPoint = (data, label, color) => {

        let className = "";
        if (data.isIP7Category) {
            className = "ip7";
        }

        return {
            name: label,
            y: parseFloat(data.value.toFixed(2)),
            color: color,
            className: className
        };
    };

    buildOuterCircle = (sortedAssets, colors) => {
        if (sortedAssets.length <= colors.length) {
            let categoryArray = sortedAssets.map((element, index) => {
                let highlightClass = "";
                if (index === this.props.highlightIndex) highlightClass = "highlightedClass";

                let color = colors[element.colorIndex];
                return this.buildOuterSection(element.children, color, highlightClass);
            });

            if (categoryArray.length > 0) {
                return categoryArray.reduce((memo, element) => {
                    return memo.concat(element);
                });
            } else {
                return "";
            }
        } else {
            return "";
        }
    };

    buildOuterSection = (category, baseColor, highlightClass) => {
        let data = [];
        if (category.length > 0 && baseColor !== undefined && baseColor !== null) {
            let _nColor = this.getShadesOfColor(baseColor, category.length + 2);

            category.forEach((element, index) => {
                let total = element.value;
                if (total === 0) return;

                let className = "";
                if (element.isIP7AssetClass) {
                    className = "ip7";
                }

                data.push({
                    name: element.name,
                    y: parseFloat(total.toFixed(2)),
                    color: _nColor[index + 2],
                    className: className
                });
            });
        }
        return data;
    };

    getShadesOfColor = (baseColor, numberOfShades) => {
        var colors = [];
        colors.unshift(Highcharts.Color(baseColor).get());
        for (var x = numberOfShades; x > 0; x--) {
            colors.unshift(Highcharts.Color(baseColor).brighten(-0.2 + ((x * 2) / numberOfShades) / 5).get());
        }

        return colors;
    };

    buildGraph = (innerCircleSeries, outerCircleSeries) => {
        let width = 750;
        if (this.props.width !== undefined) width = this.props.width;
        let enableLabels = true;
        if (width < 600) enableLabels = false;
        let series = [{
            name: "Asset Type",
            colorByPoint: true,
            data: outerCircleSeries,
            size: '90%',
            innerSize: '80%',
            states: {hover: {enabled: false}},
            dataLabels: {enabled: false},
            animation: false

        }, {
            name: "Asset Type Breakdown",
            colorByPoint: true,
            data: innerCircleSeries,
            size: '75%',
            states: {hover: {enabled: false}},
            innerSize: '50%',
            dataLabels: {
                enabled: enableLabels,
                formatter: function () {
                    return this.y > 0 ? this.point.name + ' ' + this.y + '%' : null;
                },
                style: {
                    fontWeight: "normal",
                    fontSize: "13px",
                    fontFamily: "lato, sans-serif",
                    margin: "10px",
                    width: "200px"
                },
                color: '#6F7174',
                distance: 40,
                crop: false,
                overflow: "none",
                connectorWidth: 0
            },
            animation: false

        }];

        let options = {
            chart: {
                type: 'pie',
                width: width,
                height: '250px',
                backgroundColor: 'rgba(255, 255, 255, 0.0)'
            },
            credits: {
                enabled: false
            },
            exporting: {enabled: false},
            title: {
                text: this.props.title
            },
            navigation: {
                enabled: false,
            },
            tooltip: {
                enabled: true, useHTML: true,
                snap: 2,
                formatter: function () {
                    return this.y > 0 ? this.point.name + ' ' + this.y + '%' : null;
                }
            },
            series: series
        };

        return options;
    };

    render() {

        let isValid = true;
        if (isValid && this.props.assets === undefined) {
            isValid = false;
        }
        if (isValid && this.props.width !== undefined && isNaN(this.props.width)) {
            isValid = false;
        }
        if (isValid && !isNaN(this.props.width) && this.props.width <= 0) {
            isValid = false;
        }

        try {
            if (!isValid) {
                return (
                    <div className="no-allocation-graphic"/>
                )
            } else {
                let assets = this.props.assets;
                let colors = [];

                if (this.props.colors) {
                    colors = this.props.colors;
                } else {
                    colors = ["#e6687e", "#008040", "#800000", "#0000a0", "#c0c0c0", "#d69b4e", "#7f7f7f"];
                }

                let coloredAssets = this.setColors(assets, colors);
                let sortedAssets = this.sortAssets(coloredAssets);
                let innerSeriesData = this.buildInnerCircle(sortedAssets, colors);
                let outerSeriesData = this.buildOuterCircle(sortedAssets, colors);
                let options = this.buildGraph(innerSeriesData, outerSeriesData);

                return (
                    <div>
                        <svg width="0" height="0" xmlns="http://www.w3.org/2000/svg">
                            <defs>
                                <linearGradient id="MyGradient">
                                    <stop offset="15%"  stop-color="#0066ff"/>
                                    <stop offset="95%" stop-color="#FFF"/>
                                </linearGradient>
                            </defs>
                        </svg>

                        <Charts options={options}/>

                    </div>

                )
            }
        }
        catch (err) {
            console.log("Allocation graphic data is invalid, stop rendering.");
            return <div className="no-allocation-graphic"/>
        }

    };

};

export default AllocationGraphs;


// WEBPACK FOOTER //
// ./src/containers/AllocationGraphs/AllocationGraphs.js